import { Box } from "@material-ui/core";
import React from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../config/config";
import { convertToBase64 } from "../../../../../utils/convertToBase64";
import { fakeFormsDataKYCManual } from "../../../../../utils/fakeFormsData";
import { UploadDocIdPictureButton } from "../../../../shared/components/UploadDocIdPictureButton";
import UploadDocIdPictureDialog from "../../../../shared/components/UploadDocIdPictureDialog";
import IconTitle from "../../../../shared/components/IconTitle";
import Text from "../../../../shared/components/Text";
import { docIdSide } from "../../shared/config";
import MainButton from "../../../../shared/components/MainButton";
import { ThemedAsset, assetIds } from "nemuru-components";
import { useTheme } from "@material-ui/styles";
import { developOptions } from "../../../../../config/developOptions";

export default function KycManualDocIdPicture({
  onSubmitForm,
  data,
  documentType,
}) {
  const [state, setState] = React.useState({
    imageData: developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES
      ? {
          dniEsFront: fakeFormsDataKYCManual?.DOC_ID_PICTURE.dniEsFront,
          dniEsBack: fakeFormsDataKYCManual?.DOC_ID_PICTURE.dniEsBack,
        }
      : data
      ? data
      : {},
    imageCurrentSide: {},
    openDialog: false,
  });
  const { imageData, imageCurrentSide, openDialog } = state;
  const handleClick = (side) => {
    setState((s) => ({
      ...s,
      openDialog: true,
      imageCurrentSide: side,
    }));
  };

  const handleClose = () => {
    setState((s) => ({
      ...s,
      openDialog: false,
    }));
  };

  const handleDelete = (id) => {
    let filteredImages = {};
    Object.keys(imageData).filter((key) => {
      if (key !== id) {
        return (filteredImages = {
          ...filteredImages,
          [key]: imageData[key],
        });
      } else {
        return;
      }
    });
    setState((s) => ({
      ...s,
      imageData: filteredImages,
    }));
  };

  const onUploadImage = (e) => {
    const value = e.target.files[0];
    const name = e.target.name;
    if (value) {
      convertToBase64(value, (result) => {
        setState((s) => ({
          ...s,
          imageData: {
            ...s.imageData,
            [name]: {
              result,
              file: value,
              name: value.name,
              size: value.size,
              type: value.type,
            },
          },
          imageCurrentSide: null,
          openDialog: false,
        }));
      });
    }
  };

  const { palette } = useTheme();
  return (
    <>
      <Box className="appear-anim" flex={0.3}>
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_BACK}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ID" />}
          subtitle={<Text tId="IMAGE_ID" />}
        />
      </Box>
      <Box
        flex={0.5}
        mb={2}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        className="appear-anim"
      >
        <UploadDocIdPictureButton
          currentDocIdSide={docIdSide[`${documentType}_FRONT`]}
          imageData={imageData}
          handleClick={handleClick}
          handleDelete={handleDelete}
        />
      </Box>
      <Box
        flex={1}
        mb={"2vh"}
        display="flex"
        flexDirection="column"
        justifyContent="start"
        alignItems="center"
        className="appear-anim"
      >
        <UploadDocIdPictureButton
          currentDocIdSide={docIdSide[`${documentType}_BACK`]}
          imageData={imageData}
          handleClick={handleClick}
          handleDelete={handleDelete}
        />
      </Box>
      <Box>
        <MainButton
          disabled={Object.keys(imageData).length < 2}
          onClick={() => onSubmitForm({ ...imageData })}
        >
          <Text tId="CONTINUE" />
        </MainButton>
      </Box>
      {imageCurrentSide && (
        <UploadDocIdPictureDialog
          open={openDialog}
          onClose={() => handleClose()}
          onUploadImage={onUploadImage}
          currentDocIdSide={imageCurrentSide}
        />
      )}
    </>
  );
}
